module.exports = __webpack_public_path__ + "static/media/ride.b0d70ec5.wav";


//////////////////
// WEBPACK FOOTER
// ./src/sounds/ride.wav
// module id = 182
// module chunks = 0